<template lang='pug'>
  .modals.srv-dtls.component
    table
      thead
        tr
          th {{ $t('Service') }}
          td.emphasize {{ srv.title }}
        tr
          th {{ $t('Duration') }}
          td {{ srv.duration }} {{ $t('mins') }}
        tr
          th {{ $t('Price') }}
          td ${{ srv.price }}
        tr
          th {{ $t('Details') }}
          td.desc {{ srv.description }}
    
    bf-divider.card
    
    srv-imgs( v-if='images.length' :srv='srv' :imgs='images' )
    
    .files
      h4.file( v-for=' f in files' ) 
        a( :href='f.src' target='_blank') 
          img(src='/ui/file.svg')
          span {{ f.title }}

    //- .instructions( v-if='srv.instructions' )
    //-   h5 Order Instructions:
    //-   p {{ srv.instructions }}
    
    //- .msg
    //-   bf-input
    //-     textarea( v-model='msg' placeholder='Enter a message/note' )
</template>

<script>
  import { db } from '@/main'
  import SrvImgs from '@/components/carousels/srv-imgs'

  export default {
    name: 'modals.srv-dtls.component',

    props: {
      biz: Object, 
      srv: Object, 
      collection: { type: String, default: 'services' }
    },

    components: {
      SrvImgs
    },

    data() {
      return {
        category: {},
        images: [],
        files: []
      }
    },

    firestore() {
      let ref = db.collection( this.collection ).doc( this.srv.id )

      if ( this.srv.category_id ) return {
        category: db.collection( 'categories' ).doc( this.srv.category_id ),
        images: ref.collection('images'),
        files: ref.collection( 'files' )
      }
      else return {
        images: ref.collection('images'),
        files: ref.collection( 'files' )
      }
    },

    methods: {
      reserve() {
        this.$emit('close')
        this.$emit('reserve')
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .srv-dtls
    table
      width 100%
      text-align left
      th, td
        padding 10px 10px
      th
        text-align right
        width 120px
      .emphasize
        font-weight bold
    
    .file
      color blue
      line-height 2
      text-decoration underline
      padding 10px
</style>
